const dropdownItems = [
    {id: 1, icon: "fa fa-clock-o", title: "1w", subtitle: "Recurring once every 1 week"},
    {id: 4, icon: "fa fa-clock-o", title: "3d", subtitle: "Recurring once every 3 days"},
    {id: 5, icon: "fa fa-clock-o", title: "1M", subtitle: "Recurring once every 1 month"},
    {id: 2, icon: "fa fa-refresh", title: "100cycles", subtitle: "Recurring once every 100 cycles"},
    {id: 3, icon: "fa fa-undo", title: "1return", subtitle: "Recurring once every 1 return"},
    {id: 6, icon: 'fa fa-user', title: 'Technician', subtitle: 'Responsible', showAssign: true},
    {id: 7, icon: 'fa fa-user', title: 'ATOM', subtitle: 'Responsible', showAssign: true},
    {id: 8, icon: 'fa fa-user', title: 'Service Operator', subtitle: 'Responsible', showAssign: true}
];

export default dropdownItems;
